import { isEmpty } from 'lodash'
import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const productNameResolver: FieldResolver = (metadata: Metadata) =>
  ({
    productName: !isEmpty(metadata.getProductName()) ? metadata.getProductName() : undefined
  } as StreamData)

export default productNameResolver
